import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { TimelineDataConverter } from '../interactivity-editor/classes/TimelineDataConverter';
import { ITimelineData, ITimelineApp } from '../interactivity-editor/redux/timeline-data.model';
import { InteractivityActionService } from '../interactivity-editor/services/interactivity-action.service';
import { OverlayService } from '../../../services/overlay.service';
import { SapiService } from '../../../services/sapi.service';
import { TranslateService } from '@ngx-translate/core';
import { InteractivityEditorService } from '../interactivity-editor/services/interactivity-editor.service';
import { Router } from '@angular/router';
import { TIMELINE_DATA_INITIAL_STATE } from '../interactivity-editor/redux/timeline-data.store';
import { IWidget } from '../interactivity-editor/interfaces/IWidget';
import { Subscription } from 'rxjs';
import { InteractivityWidgetSelectionService } from '../interactivity-editor/services/interactivity-widget-selection.service';
import { InteractivityDesignDimensionsService } from '../interactivity-editor/services/interactivity-design-dimensions.service';

@Component({
	selector: 'bb-edit-app',
	templateUrl: './bb-edit-app.component.html',
	styleUrls: ['./bb-edit-app.component.scss']
})

export class BbEditAppComponent implements OnInit, OnDestroy {
	@Input() app: ITimelineApp;
	@Input() modal: any;
	@Output() designDimensionsChanged: EventEmitter<any> = new EventEmitter<any>();
	timeline: ITimelineData;
	timelineWidgets: IWidget[] = [];
	selectionOptions: any[] = [];
	aspectRatio: number;
	aspectRatioLocked = true;
	createNew = false;
	appDefaults: ITimelineApp = {
		name: '',
		description: '',
		exposedProperties: {},
		width: 1920,
		height: 1080
	};
	optionsByType: any = null;

	private subscriptions = new Subscription();

	constructor(
		public actionService: InteractivityActionService,
		private editorService: InteractivityEditorService,
		private widgetSelectionService: InteractivityWidgetSelectionService,
		private sapiService: SapiService,
		private designDimensionsService: InteractivityDesignDimensionsService,
		private translate: TranslateService,
		private router: Router,
		private overlayService: OverlayService) {

	}

	ngOnInit() {
		if (this.app) {
			this.app = { ...this.appDefaults, ...this.app };
			if (!this.app.exposedProperties) {
				this.app.exposedProperties = {};
			}
		} else {
			this.createNew = true;
			this.app = { ...this.appDefaults };
			const newApp = { ...TIMELINE_DATA_INITIAL_STATE.data };
			this.app.timelines = [newApp];
		}
		if (!this.app.width) {
			this.app.width = 1920;
		}
		if (!this.app.height) {
			this.app.height = 1080;
		}
		this.aspectRatio = this.app.width / this.app.height;
		if (this.app && this.app.timelines && this.app.timelines[0]) {
			this.timeline = TimelineDataConverter.convertOldTimelineData(this.app.timelines[0]);
		}

		this.subscriptions.add(this.editorService.widgetsSubject.subscribe((widgets) => {
			const optionsByType = {};
			this.timelineWidgets = [...widgets].reverse();
			this.timelineWidgets.forEach((w) => {
				if (w.type && !optionsByType[w.type]) {
					optionsByType[w.type] = this.getExtendedOptions(w);
				}
			});
			this.optionsByType = optionsByType;
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	getExtendedOptions(widget: IWidget) {
		const handlers: any[] = this.widgetSelectionService.getCommonProperties([widget])
			.filter((prop) => prop.key.match(/^on/))
			.map((prop) => ({
				label: prop.key,
				value: prop.key
			}));
		return [...this.actionService.getWidgetPropOptionsForType(widget.type), ...handlers];
	}

	onDimensionChanged(prop: 'w' | 'h') {
		if (this.aspectRatioLocked) {
			if (prop === 'w') {
				this.app.height = this.app.width / this.aspectRatio;
			} else {
				this.app.width = this.app.height * this.aspectRatio;
			}
		} else {
			this.aspectRatio = this.app.width / this.app.height;
		}
	}

	onDeleteClick() {
		console.warn('delete TODO');
	}


	onCancelClick() {
		if (this.createNew) {
			this.closeModal();
		} else {
			this.sapiService.get('app', this.app.id).subscribe((data) => {
				this.app = data;
				this.editorService.parentEntitySubject.next(data);
				this.closeModal();
			});
		}
	}

	closeModal() {
		if (this.modal) {
			this.overlayService.removeModal(this.modal);
		}
	}

	onSaveClick() {
		if (this.createNew) {
			this.sapiService.create('app', this.app).subscribe((data: any) => {
				if (data && data.timelines && data.timelines[0] && data.timelines[0].id) {
					this.router.navigate(['/library/interactivity/', data.timelines[0].id]);
				}
			});
		} else {
			this.designDimensionsService.setDesignDimensions({
				width: this.app.width,
				height: this.app.height
			});
			this.sapiService.update('app', this.app).subscribe((data) => {
				this.editorService.parentEntitySubject.next(data);
				this.overlayService.createToast(this.translate.instant('TEMPLATE_SAVED'), 'check');
				this.closeModal();
			});
		}
	}
}
